<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.inspectgroup_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="groupPersonName2Form" slot-scope="row">
        <select-group
          ref="select"
          @getData="getDate"
          :dictData="row.dic"
          dictKey="realName"
          dictValue="id"
          type="people"
          :people="row.row.groupPersonName"
        >
        </select-group>
      </template>
      <template slot="groupPersonName2Label">
        <span><span style="color: red;">*&nbsp;</span>班组人员</span>
      </template>
      <template slot="groupPersonName" slot-scope="{ row }">
        <el-tag>{{ groupPersonNameList(row, row.groupPersonName) }}</el-tag>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getUserList,
} from '@/api/v4ward/inspectgroup/inspectgroup';
import { mapGetters } from 'vuex';
import selectGroup from '@/components/inspect/select-group.vue';

var V = (rule, value, callback) => {
  if (value > 24) {
    callback(new Error('班组最大计划数量请控制在1-24'));
  } else if (value < 1) {
    callback(new Error('班组最大计划数量请控制在1-24'));
  } else {
    callback();
  }
};
export default {
  components: {
    'select-group': selectGroup,
  },
  data() {
    return {
      userList: [],
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        columnBtn: false,
        searchLabelWidth: 100,
        refreshBtn: false,
        labelWidth: 250,
        column: [
          {
            label: '所属小区',
            prop: 'propertyId',
            type: 'tree',
            dataType: 'string',
            row: true,
            span: 20,
            dicUrl: 'api/base/property/treeChildrenPowerNode',
            props: { label: 'objectFullName', value: 'id' },
            search: true,
            rules: [
              {
                required: true,
                message: '请选择所属小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '班组名称',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            type: 'tree',
            dataType: 'string',
            dicUrl: 'api/inspectGroup/inspectGroupTree',
            props: { label: 'groupName', value: 'id' },
          },
          {
            label: '班组名称',
            prop: 'groupName',
            row: true,
            span: 20,
            maxlength: 30,
            showWordLimit: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入班组名称',
                trigger: 'blur',
              },
            ],
            searchPlaceholder: '模糊匹配班组名称',
          },
          {
            label: '班组人员',
            prop: 'groupPersonName',
            // type: 'tree',
            // multiple: true,
            row: true,
            span: 20,
            hide: false,
            viewDisplay: false,
            overHidden: true,
            dataType: 'string',
            clearable: false,
            slot: true,
            addDisplay: false,
            editDisplay: false,
            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择班组人员',
                trigger: 'blur',
              },
            ],
          },

          {
            label: '班组人员',
            prop: 'groupPersonName1',
            type: 'textarea',
            // multiple: true,
            row: true,
            span: 20,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: '班组人员',
            prop: 'groupPersonName2',
            // type: 'tree',
            // multiple: true,
            row: true,
            span: 20,
            formslot: true,
            typeslot: true,
            labelslot: true,
            hide: true,
            viewDisplay: false,
            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
          },
          {
            label: '班组负责人',
            prop: 'groupPrincipalId',
            search: true,
            type: 'tree',
            row: true,
            span: 20,
            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择班组负责人',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '班组最大计划数量',
            prop: 'planCount',
            span: 20,
            rules: [
              {
                required: true,
                message: '请选择班组最大计划数量',
                trigger: 'blur',
              },
              {
                validator: V,
                message: '班组最大计划数量请控制在1-24',
                trigger: 'blur',
              },
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数', trigger: 'blur' },
            ],
          },
          {
            label: '备注',
            type: 'textarea',
            prop: 'remark',
            span: 20,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspectgroup_add, false),
        viewBtn: this.vaildData(this.permission.inspectgroup_view, false),
        delBtn: this.vaildData(this.permission.inspectgroup_delete, false),
        editBtn: this.vaildData(this.permission.inspectgroup_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    getUserList().then(({ data }) => {
      this.userList = data;
    });
  },
  methods: {
    getDate(data) {
      let groupPersonName = [];
      data.forEach((item, index, arr) => {
        groupPersonName.push(item.id);
      });
      this.form.groupPersonName = groupPersonName;

      // console.log(groupPersonName);
    },
    groupPersonNameList(row, id) {
      let groupPersonName = [];
      let list = [];
      list = id.split(',');
      list.forEach((s) => {
        this.userList.forEach((data) => {
          if (s == data.id) {
            groupPersonName.push(data.realName);
            return;
          }
        });
      });
      row.groupPersonName1 = [];
      row.groupPersonName1 = groupPersonName.join('，');
      return groupPersonName.join('，');
    },
    rowSave(row, loading, done) {
      if (row.groupPersonName.length === 0) {
        this.$message.error('班组人员不能为空');
        done();
        return;
      }
      row.groupPersonName = row.groupPersonName.join(',');
      console.log(row);
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      if (row.groupPersonName.length === 0) {
        this.$message.error('班组人员不能为空');
        done();
        return;
      }
      if (row.groupPersonName instanceof Array) {
        row.groupPersonName = row.groupPersonName.join(',');
      }
      console.log(row);
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
